import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../../assets/css/style.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import * as utils from '../../utils';

class DisplayMonitor extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let viewport = utils.getViewport();

    if (viewport == 'xs' || viewport == 'sm') {
      let classNames = 'display-monitor-mobile-state rounded-circle';

      if (this.props.monitorData.monitor.currentState) {
        classNames += Boolean(
          this.props.monitorData.monitor.currentState.appIsRun,
        )
          ? ' bg-success'
          : ' bg-secondary';
      } else {
        classNames += ' bg-warning';
      }

      // switch (this.props.monitorData.monitor.state) {
      //     case 0:
      //         classNames += " bg-success";
      //         break;
      //     case 1:
      //         classNames += " bg-warning";
      //         break;
      //     case 2:
      //         classNames += " bg-danger";
      //         break;
      //     case -1:
      //     default:
      //         classNames += " bg-secondary";
      // }

      return (
        <div
          className="display-monitor-mobile d-flex justify-content-between align-items-center border rounded p-1"
          onClick={this.props.onClick}
          title={this.props.monitorData.monitor.lastMessage}
        >
          <div className={classNames}></div>
          <span className="ml-2">
            {this.props.monitorData.display.id} (
            {this.props.monitorData.display.description})
          </span>
          <div className="dropdown ml-2">
            <button
              className="btn btn-secondary"
              type="button"
              data-toggle="dropdown"
              title="Действия"
            >
              <FontAwesomeIcon icon="ellipsis-h" size="sm" color="#fff" />
            </button>
            {this.props.isUserAdmin ? (
              <div className="dropdown-menu dropdown-menu-right">
                {/* <Link to={"/logs/" + this.props.monitorData.display.id} className="dropdown-item dropdown-item-custom">
                                    Просмотреть события
                                </Link> */}
                <Link
                  to={
                    '/displays/' +
                    this.props.monitorData.display.id +
                    '/details?return_url=/monitor'
                  }
                  className="dropdown-item dropdown-item-custom"
                >
                  Изменить данные
                </Link>
                <a
                  className="dropdown-item dropdown-item-custom"
                  href="#runCommandModal"
                  data-toggle="modal"
                >
                  Послать команду
                </a>
              </div>
            ) : (
              <div className="dropdown-menu">
                <Link
                  to={'/logs/' + this.props.monitorData.display.id}
                  className="dropdown-item dropdown-item-custom"
                >
                  Просмотреть события
                </Link>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      let classNames = 'display-monitor-content text-center';
      // switch (this.props.monitorData.monitor.state) {
      //     case 0:
      //         classNames += " bg-success";
      //         break;
      //     case 1:
      //         classNames += " bg-warning";
      //         break;
      //     case 2:
      //         classNames += " bg-danger";
      //         break;
      //     case -1:
      //     default:
      //         classNames += " bg-secondary";
      // }

      if (this.props.monitorData.monitor.currentState) {
        classNames += Boolean(
          this.props.monitorData.monitor.currentState.appIsRun,
        )
          ? ' bg-success'
          : ' bg-secondary';
      } else {
        classNames += ' bg-warning';
      }

      return (
        <div className="display-monitor" onClick={this.props.onClick}>
          <div className={classNames}>
            <p>{`${this.props.monitorData.display.id} [ ${this.props.monitorData.display.checkpoint.name} ]`}</p>
            <p>{this.props.monitorData.display.description}</p>

            <p className="mt-2">{`В сети: ${
              this.props.monitorData.monitor.lastSeen
                ? new Date(
                    this.props.monitorData.monitor.lastSeen,
                  ).toLocaleString()
                : 'неизвестно'
            }`}</p>
          </div>
          {this.props.isUserAdmin ? (
            <div className="list-group list-group-horizontal bg-dark display-monitor-actions">
              {/* <Link to={"/logs/" + this.props.monitorData.display.id} className="list-group-item " title="Просмотреть события">
                                <FontAwesomeIcon icon="list" size="sm" color="#fff" />
                            </Link> */}
              <Link
                to={
                  '/displays/' +
                  this.props.monitorData.display.id +
                  '/details?return_url=/monitor'
                }
                className="list-group-item "
                title="Изменить данные"
              >
                <FontAwesomeIcon icon="pencil-alt" size="sm" color="#fff" />
              </Link>
              <a
                className="list-group-item "
                href="#runCommandModal"
                data-toggle="modal"
                title="Послать команду"
              >
                <FontAwesomeIcon icon="play" size="sm" color="#fff" />
              </a>
            </div>
          ) : (
            <div className="list-group list-group-horizontal bg-dark display-monitor-actions">
              <Link
                to={'/logs/' + this.props.monitorData.display.id}
                className="list-group-item "
                title="Просмотреть события"
              >
                <FontAwesomeIcon icon="list" size="sm" color="#fff" />
              </Link>
            </div>
          )}
        </div>
      );
    }
  }
}

export default DisplayMonitor;

{
  /* <Link to={"/displays/" + this.props.monitorData.display.id + "/settings"} className="list-group-item " title="Изменить настройки">
                                    <FontAwesomeIcon icon="cog" size="sm" color="#fff" />
                                </Link> */
}
